module.exports = __webpack_public_path__ + "static/media/soft-fit-cereja-trans.39e2f9f6.png";